import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetLoginUserData } from '../types';

//(ref: admin_event_payload_do_not_display_special_only)
// only the field doNotDisplaySpecialUseOnlyDt
export const GET_LOGIN_USER: TypedDocumentNode<IGetLoginUserData> = gql`
  query getLoginUser {
    viewer {
      id
      username
      confirmed
      email
      active
      role
      room {
        id
        title
      }
      site {
        id
        title
        orgId
        testCenterCd
        event {
          asmtEventId
          asmtEventTypeCd
          asmtId
          doNotDisplaySpecialUseOnlyDt
          eventDisplayDescr
          eventEndDt
          eventStartDt
          eventTitle
          tdtkAsmtType
        }
      }
      welcomed
    }
  }
`;
